import { atom } from 'jotai';

// Lives in its own module so `GlobalModalsWrapper` and every snippet trigger
// site can import the atom without statically pulling in the full
// `snippet-editor-modal.tsx` chunk (form, mutations, validation, etc.) and
// defeating the `dynamic()` lazy load in `GlobalModalsWrapper`.

export type SnippetModalState = {
  open: boolean;
  // `from` is the analytics trigger origin. Declared by each trigger site
  // rather than inferred from the current route, which mis-attributed
  // Settings opens on top of a session page as `editor`.
  from: 'editor' | 'settings';
  initialSnippet?: {
    shorthand: string;
    content: string;
    trigger_phrase?: string | null;
    is_verbal_trigger?: boolean | null;
    id?: string;
  };
  isEditing: boolean;
};

export const snippetModalAtom = atom<SnippetModalState>({
  open: false,
  from: 'settings',
  initialSnippet: undefined,
  isEditing: false,
});

// Boolean selector so `GlobalModalsWrapper` can gate the lazy-mounted
// `SnippetModal` without re-rendering whenever `initialSnippet` or `isEditing`
// change while the modal is open.
export const snippetModalOpenAtom = atom((get) => get(snippetModalAtom).open);

// Canonical closed state. Every close path resets to this so the atom never
// retains the previous session's `from` while closed — TS still requires
// callers to pass `from` on every open, but resetting here makes the atom
// self-documenting against programmatic writes that might bypass the type.
export const CLOSED_SNIPPET_MODAL_STATE: SnippetModalState = {
  open: false,
  from: 'settings',
  isEditing: false,
  initialSnippet: undefined,
};
